export const constant = {
	bigNumber: 1e5,
	drugLicenseRegex: /^([^\d]*\d){12}[^\d]*$/,
	panCardRegex: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
	emailRegex: /\S+@\S+\.\S+/,
	gstRegex: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/,
};

export const CREDIT_NOTE_TYPE = {
	1: 'Damaged/Returned Goods',
	2: 'Excess Payment',
	3: 'Advance Payment',
};
